<template src="./index.html"></template>
<script>
import bsdlcontent from '@/components/common/bsdlcontent/index.vue';
import { queryGatewayInfo } from '@/api/organization';
export default {
	name: 'auth',
	components: {
        bsdlcontent
	},
	data: function() {
		return {
            drawer: true,
            rpaFormData: {},
            logId: 0,
		};
	},
	mounted() {
    },
	created() {
        let companyId = this.$route.query.companyId;
        this.logId = this.$route.query.logId;
        queryGatewayInfo({companyId: companyId}).then(res => {
            if (res.data.code === 1) {
                this.rpaFormData = res.data.data[0];
            }
        })
	},
	methods: {
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
